import BaseAttributeManager from "./Base/AttributeManager";
import BaseConstants from "./Base/Constants";
import BaseEEObject from "./Base/EEObject";
import BaseEnsure from "./Base/Ensure";
import BaseIDObject from "./Base/IDObject";
import BaseIdResolver from "./Base/IdResolver";
import BaseMessageException from "./Base/MessageException";
import BaseNamespace from "./Base/Namespace";
import BaseNSDictionary from "./Base/NSDictionary";
import BaseNSIdentity from "./Base/NSIdentity";
import BaseNSSet from "./Base/NSSet";
import BaseTypes from "./Base/Types";
import BaseUtility from "./Base/Utility";
import BaseXMLHttpRequestAsync from "./Base/XMLHttpRequestAsync";
import BaseXMLReader from "./Base/XMLReader";
import ComponentsGrimoireComponent from "./Components/GrimoireComponent";
import ConvertersArrayConverter from "./Converters/ArrayConverter";
import ConvertersBooleanConverter from "./Converters/BooleanConverter";
import ConvertersComponentConverter from "./Converters/ComponentConverter";
import ConvertersEnumConverter from "./Converters/EnumConverter";
import ConvertersNumberArrayConverter from "./Converters/NumberArrayConverter";
import ConvertersNumberConverter from "./Converters/NumberConverter";
import ConvertersObjectConverter from "./Converters/ObjectConverter";
import ConvertersStringArrayConverter from "./Converters/StringArrayConverter";
import ConvertersStringConverter from "./Converters/StringConverter";
import InterfaceGomlInterfaceImpl from "./Interface/GomlInterfaceImpl";
import InterfaceGrimoireInterface from "./Interface/GrimoireInterface";
import InterfaceGrimoireInterfaceImpl from "./Interface/GrimoireInterfaceImpl";
import InterfaceNodeInterface from "./Interface/NodeInterface";
import NodeAttribute from "./Node/Attribute";
import NodeComponent from "./Node/Component";
import NodeComponentDeclaration from "./Node/ComponentDeclaration";
import NodeGomlLoader from "./Node/GomlLoader";
import NodeGomlNode from "./Node/GomlNode";
import NodeGomlParser from "./Node/GomlParser";
import NodeNodeDeclaration from "./Node/NodeDeclaration";
import NodeNodeUtility from "./Node/NodeUtility";
export const __VERSION__ = "0.21.1";
export const __NAME__ = "grimoirejs";
import __MAIN__ from "./main";
let __EXPOSE__ = {
    "Base": {
        "AttributeManager": BaseAttributeManager,
        "Constants": BaseConstants,
        "EEObject": BaseEEObject,
        "Ensure": BaseEnsure,
        "IDObject": BaseIDObject,
        "IdResolver": BaseIdResolver,
        "MessageException": BaseMessageException,
        "Namespace": BaseNamespace,
        "NSDictionary": BaseNSDictionary,
        "NSIdentity": BaseNSIdentity,
        "NSSet": BaseNSSet,
        "Types": BaseTypes,
        "Utility": BaseUtility,
        "XMLHttpRequestAsync": BaseXMLHttpRequestAsync,
        "XMLReader": BaseXMLReader
    },
    "Components": {
        "GrimoireComponent": ComponentsGrimoireComponent
    },
    "Converters": {
        "ArrayConverter": ConvertersArrayConverter,
        "BooleanConverter": ConvertersBooleanConverter,
        "ComponentConverter": ConvertersComponentConverter,
        "EnumConverter": ConvertersEnumConverter,
        "NumberArrayConverter": ConvertersNumberArrayConverter,
        "NumberConverter": ConvertersNumberConverter,
        "ObjectConverter": ConvertersObjectConverter,
        "StringArrayConverter": ConvertersStringArrayConverter,
        "StringConverter": ConvertersStringConverter
    },
    "Interface": {
        "GomlInterfaceImpl": InterfaceGomlInterfaceImpl,
        "GrimoireInterface": InterfaceGrimoireInterface,
        "GrimoireInterfaceImpl": InterfaceGrimoireInterfaceImpl,
        "NodeInterface": InterfaceNodeInterface
    },
    "Node": {
        "Attribute": NodeAttribute,
        "Component": NodeComponent,
        "ComponentDeclaration": NodeComponentDeclaration,
        "GomlLoader": NodeGomlLoader,
        "GomlNode": NodeGomlNode,
        "GomlParser": NodeGomlParser,
        "NodeDeclaration": NodeNodeDeclaration,
        "NodeUtility": NodeNodeUtility
    }
};
let __BASE__ = __MAIN__();
Object.assign(__EXPOSE__, {
    __VERSION__: __VERSION__,
    __NAME__: __NAME__
});
Object.assign(__BASE__ || {}, __EXPOSE__);
window["GrimoireJS"]["__VERSION__"] = __VERSION__;
export default __BASE__;



// WEBPACK FOOTER //
// ./src/index.ts